<!--
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-11-14 16:19:33
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-11-15 16:19:21
 * @FilePath: \合联\oms\src\view\double\list\adjust.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-11-14 16:19:33
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-11-15 10:23:35
 * @FilePath: \合联\oms\src\view\double\list\adjust.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
    ref="table">
  </cTable>
</template>

<script>
import cTable from '@/base/common/index';
import { apis } from '@/api/double/adjust'
import { upload } from '@/api/public'
import { printData } from './print'
import getLodop from "@/utils/lodop";

export default {
  name: "",
  components: {
    cTable
  },
  props: {
    awbno: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      methods: {
        ...apis,
        list: (p) => {
          console.log(this.awbno);
          p.awbno = this.awbno
          return apis.list(p)
        },
        beforeHandleList({ data }) {
          return data
        },
        upload
      },
      config: {
        isGetList: false,
        slot: 'div',
        height: 600,
        resize: false,
        awbno: this.awbno
      },
      footer: {},
      modals: {
        add: {
          type: 'add',
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ airway_number: this.$page.config.awbno, details: this.list })
              data.src = data.src.map(t => t.src)
              this.$page.handleRequestMethods('save', data, true, true).then(res => {
                this.$page.getList();
                close();
              })
            }
          },
          config: {
            title: this.$tz('新增'),
            modalBind: {
              width: 1000
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: '20px'
              }
            },
            rules: {
              cause: [
                {
                  required: true,
                  message: 'cannot be empty',
                  trigger: 'blur',
                },
              ],
              src: [
                {
                  required: true,
                  message: 'cannot be empty',
                  trigger: 'blur',
                  type: 'array',
                },
              ],
            }
          },
          grid: [
            { cause: 24 },
            { src: 24 },
          ],
          fields: [
            {
              key: 'cause',
              name: () => this.$tz('调账,原因'),
              placeholder() {
                return this.$tz('调账,原因');
              },
              component: 'Input',
              bind: {
                type: 'textarea',
                autosize: { minRows: 2 },
              },
            },
            {
              name: () => this.$t("updateFile") + this.$t("files"),
              key: "src",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: true,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls,.doc,.docx,.pdf,.jpg,.png,.jpeg,.gif",
              },
              default: [],
              methods: {
                beforeUpload({ file, formData }) {
                  let data = new FormData();
                  data.append("file", file);
                  data.append("type", 'adjust');
                  this.$page.handleRequestMethods('upload', data, true, true).then((res) => {
                    formData["src"].push({
                      filename: file.name,
                      src: res.payload,
                    });
                  });
                  return false;
                },
              },
            },
          ],
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$tz('收费,项目'),
                key: 'expense_item',
                minWidth: 110,
                component: 'Select',
                optionsFn: 'expense',
                options: [],
              },
              {
                name: () => this.$tz('计费,方式'),
                key: 'unit_name',
                minWidth: 110,
                component: 'Select',
                optionsFn: 'charging',
                apiData: {
                  airway_number: this.awbno
                },
                options: [],
              },
              {
                name: () => this.$tz('计费,币种'),
                key: 'currency',
                minWidth: 110,
                component: 'Select',
                optionsFn: 'getCurrency',
                options: [],
              },
              {
                name: () => this.$tz('计费,金额'),
                key: 'total_amount',
                minWidth: 110,
                component: 'Input',
                options: [],
              },
            ]
          }
        },
        files: {
          config: {
            title: this.$tz('附件'),
            modalBind: {
              width: 500
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$tz('文件,名称'),
                key: 'name',
                minWidth: 110,
              },
              {
                name: () => this.$t('operation'),
                type: 'btns',
                width: 220,
                fixed: 'right',
                list: [
                  {
                    name: this.$tz('下载'),
                    type: 'down',
                    fnName: 'down',
                    bind: {
                      type: 'primary'
                    },
                  },
                ],
                methods: {
                  down({ row }) {
                    this.openUrl(row.src)
                  },
                }
              }
            ]
          }
        },
        detail: {
          config: {
            title: this.$tz('详情'),
            modalBind: {
              width: 1000
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$tz('操作,区间'),
                key: 'type',
                minWidth: 110,
              },
              {
                name: () => this.$tz('收费,项目'),
                key: 'expense_name',
                minWidth: 110,
              },
              {
                name: () => this.$tz('计费,方式'),
                key: 'unit_txt',
                minWidth: 110,
              },
              {
                name: () => this.$tz('计费,币种'),
                key: 'currency',
                minWidth: 110,
              },
              {
                name: () => this.$tz('计费,金额'),
                key: 'total_amount',
                minWidth: 110,
              },
            ]
          }
        },
      },
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz('新增'),
              type: 'add',
              fnName: 'add',
              bind: {
                type: 'primary'
              },
            },
          ],
          methods: {
            add() {
              this.handleRequestMethods('select', { awbno: this.config.awbno }).then(res => {
                this.getModal('add').open({}, function () {
                  this.setTitle(this.$tz('新增'));
                  this.list = res.payload
                });
              })

            }
          }
        }
      },
      fields: [
        {
          name: () => this.$tz('调账,原因'),
          key: 'cause',
          minWidth: 110,
        },
        {
          name: () => this.$tz('操作人'),
          key: 'create_name',
          minWidth: 110,
        },
        {
          name: () => this.$tz('操作时间'),
          key: 'create_time',
          minWidth: 110,
        },
        {
          name: () => this.$t('operation'),
          type: 'btns',
          width: 220,
          fixed: 'right',
          list: [
            {
              name: this.$tz('详情'),
              type: 'detail',
              fnName: 'detail',
              bind: {
                type: 'primary'
              },
            },
            {
              name: () => this.$tz('附件'),
              type: 'files',
              fnName: 'files',
              bind: {
                type: 'primary'
              },
            },
            {
              name: () => this.$tz('打印'),
              type: 'print',
              fnName: 'print',
              bind: {
                type: 'success'
              },
            },
          ],
          methods: {
            print({ row }) {
              this.handleRequestMethods('print', { id: row.id }, true, true).then(res => {
                console.log('res :>> ', res);
                let lodop = getLodop(this);
                LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
                LODOP.SET_PRINT_PAGESIZE(1, "210mm", "297mm", ""); //规定纸张大小；使用A4纸
                LODOP.SET_PRINT_STYLEA(0, "ItemType", 1); //ItemType:设置上面的为页眉页脚，每页固定位置输出
                LODOP.ADD_PRINT_HTML(
                  0,
                  0,
                  "210mm",
                  "297mm",
                  printData(res.payload)
                );
                LODOP.PREVIEW(); //打印预览
              })

            },
            detail({ row }) {
              this.handleRequestMethods('detail', { id: row.id }, false, true).then(res => {
                this.getModal('detail').open(row, function () {
                  this.setTitle(this.$tz('详情'));
                  this.list = res.payload
                });
              })
            },
            files({ row }) {
              this.handleRequestMethods('src', { id: row.id }, false, true).then(res => {
                this.getModal('files').open(row, function () {
                  this.setTitle(this.$tz('附件'));
                  this.list = res.payload
                });
              })
            }
          }
        }
      ]
    }
  }
}
</script>

<style scoped></style>